<template>
  <div>
    <v-skeleton-loader v-if="loading" type="table"></v-skeleton-loader>
    <v-data-table :headers="encabezados" :items="listado" :search="search" v-else>
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th :colspan="headers.length">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Ingrese busqueda"
                single-line
                hide-details
              ></v-text-field>
            </th>
          </tr>
        </thead>
      </template>
      <template
        v-slot:item.fechaAlta="{ item }"
      >{{ item.fechaAlta | moment("dddd D [de] MMMM YYYY HH:mm") }}</template>
      <template v-slot:item.acciones="{ item }">
        <v-icon small class="mr-2" v-if="acciones.editar" @click="editarItem(item._id)">mdi-pencil</v-icon>
        <v-icon small class="mr-2" v-if="acciones.ver" @click="verItem(item._id)">mdi-eye</v-icon>
        <v-icon
          small
          class="mr-2"
          v-if="acciones.presupuesto"
          @click="abrirPresupuesto(item._id)"
        >mdi-cash-plus</v-icon>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Componente_Listado",
  props: {
    datos: String, // "/personas/cliente",
    encabezados: Array,
    acciones: Object
  },
  data() {
    return {
      search: "",
      listado: [],
      loading: true
    };
  },
  methods: {
    editarItem(id) {
      this.$router.push(`${this.acciones.editar}${id}`);
    },
    verItem(id) {
      this.$router.push(`${this.acciones.ver}${id}`);
    },
    async abrirPresupuesto(id) {
      try {
        const presupuesto = await axios.get(`/presupuesto/${id}`);
        this.$router.push({
          name: "Ventas_Nuevo",
          params: { presupuesto: presupuesto.data }
        });
      } catch (e) {
        alert(e);
      }
    }
  },
  async created() {
    try {
      const listado = await axios.get(this.datos);
      this.listado = listado.data;
      this.loading = false;
    } catch (error) {
      alert("No se pudo obtener el listado.");
    }
  }
};
</script>
